import { AccountActions } from "../action-types/accountActionTypes";

// Checklist Action

export const getAccountDetailsList = (payload) => {
  return {
    type: AccountActions.GET_USER_ACCOUNT_DETAILS_LIST,
    payload,
  };
};

export const setAccountDetailsList = (payload) => {
  return {
    type: AccountActions.SET_USER_ACCOUNT_DETAILS_LIST,
    payload,
  };
};

export const updateAccountDetailsList = (payload) => {
  return {
    type: AccountActions.UPDATE_USER_ACCOUNT_DETAILS,
    payload,
  };
};

export const updateAccountPasswordList = (payload) => {
  return {
    type: AccountActions.UPDATE_USER_ACCOUNT_PASSWORD,
    payload,
  };
};

export const setIsOpenModelEditAccountPassword = (payload) => {
  return {
    type: AccountActions.IS_OPEN_MODELS_EDIT_USER_ACCOUNT_PASSWORD,
    payload,
  };
};
